export const VIDEO_GENERATION_MIN_INTERVAL_MS = 1000;

export const VIDEO_GENERATION_RATE_LIMIT_MESSAGE = '请求过于频繁，请稍后再试';

let lastVideoGenerationAttemptAt = 0;

/** 全局 1 秒内只允许一次视频生成请求；通过校验时会更新上次成功时间。 */
export function tryBeginVideoGeneration(): boolean {
  const now = Date.now();
  if (now - lastVideoGenerationAttemptAt < VIDEO_GENERATION_MIN_INTERVAL_MS) {
    return false;
  }
  lastVideoGenerationAttemptAt = now;
  return true;
}
